import { z } from 'zod'

/**
 * A calendar day, `YYYY-MM-DD`, and a real one. For a date that is a day and
 * not an instant: when a backflow was last tested, the day a visit started.
 *
 * Real means it reads back as itself. `Date` takes a February 31st and
 * quietly makes it March 3rd, which would store a visit, or a test, on a day
 * nobody entered.
 */
export const calendarDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Use a date like 2026-04-15')
  .refine((value) => {
    const parsed = new Date(`${value}T00:00:00Z`)
    return (
      !Number.isNaN(parsed.getTime()) &&
      parsed.toISOString().slice(0, 10) === value
    )
  }, 'That is not a real date')
